module.exports = __webpack_public_path__ + "img/logo-data-studio.093bbaad.webp";